const TCF_LOCATOR_NAME = '__tcfapiLocator';

export const addLocatorFrame = (win: Window): void => {
  const doc: Document = win.document;
  const otherCMP: boolean = !!(win.frames[TCF_LOCATOR_NAME]);

  if (otherCMP) return;

  if (doc.body) {
    const iframe = doc.createElement('iframe');
    iframe.style.cssText = 'display:none';
    iframe.name = TCF_LOCATOR_NAME;
    doc.body.appendChild(iframe);
  } else {
    setTimeout(() => addLocatorFrame(win), 5);
  }
}

export const lookupCmpFrame = (win: Window): Window | undefined => {
  let frameLocator: Window = win;
  let cmpFrame: Window | undefined;
  // Iterate up to the top window checking for an already-created "__tcfapilLocator" frame on every level.
  // If one exists already then we are not the master CMP and will not queue commands.
  while (frameLocator) {
    try {
      // throws a reference error if no frames exist
      if (frameLocator.frames[TCF_LOCATOR_NAME]) {
        cmpFrame = frameLocator;
        break;
      }
    } catch (ignore) {
      // noop
    }

    // if we're at the top and no cmpFrame
    if (frameLocator === win.top) {
      break;
    }

    // move up
    frameLocator = frameLocator.parent;
  }

  return cmpFrame;
}
